/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Lifts_StartInputs */

const en_us2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starting point`)
};

const pt_br2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ponto de partida`)
};

const es_419_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`punto de partida`)
};

const pt_pt2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ponto de partida`)
};

const fr_fr2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`point de départ`)
};

const de_de2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgangspunkt`)
};

const it_it2_progress_lifts_start = /** @type {(inputs: Progress_Lifts_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`punto di partenza`)
};

/**
* | output |
* | --- |
* | "starting point" |
*
* @param {Progress_Lifts_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_start = /** @type {((inputs?: Progress_Lifts_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_start(inputs)
	if (locale === "es-419") return es_419_progress_lifts_start(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_start(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_start(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_start(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_start(inputs)
	return en_us2_progress_lifts_start(inputs)
});
export { progress_lifts_start as "progress.lifts_start" }